export default __webpack_public_path__ + "static/media/critique.36472415.jpg";